import type { AskPagePrice } from "./pageVars";

export const TYPE_ORDER: Record<AskPagePrice["type"], number> = {
	pass_24h: 0,
	pass_7d: 1,
	subscription: 2,
};

export const TYPE_LABEL: Record<AskPagePrice["type"], string> = {
	pass_24h: "24 hours",
	pass_7d: "7 days",
	subscription: "1 month",
};

export const TIER_COPY: Record<
	AskPagePrice["type"],
	{ blurb: string; perks: (name: string) => string[] }
> = {
	pass_24h: {
		blurb: "A day with everything open. For one question you came for.",
		perks: () => [
			"Every board in scope for 24 hours",
			"Watch every clip in full",
			"Ends on its own — nothing to cancel",
		],
	},
	pass_7d: {
		blurb: "A week of full access, then it ends on its own.",
		perks: () => [
			"Every board in scope for 7 days",
			"Watch every clip in full",
			"Ends on its own — nothing to cancel",
		],
	},
	subscription: {
		blurb: "Rolling access, with the monthly live call included.",
		perks: (name) => [
			"Every board in scope, always",
			`Monthly live Q&A with ${name}`,
			"Cancel any time",
		],
	},
};

export const sortPrices = (prices: AskPagePrice[]): AskPagePrice[] =>
	[...prices].sort((a, b) => TYPE_ORDER[a.type] - TYPE_ORDER[b.type]);
